export const getBooleanConfigValue = (key: string): boolean =>
  Boolean(Number(key));
